import { Component } from '@theme/component';

/**
 * Fixed side navigation that scroll-spies a set of page sections via
 * IntersectionObserver, toggling `.active` on the matching link.
 * Each `ref="links[]"` anchor carries `data-target` matching another
 * section's "Scroll-nav anchor ID" setting.
 *
 * @extends Component<{ links: HTMLAnchorElement[] }>
 */
class ScrollNavComponent extends Component {
  requiredRefs = ['links'];

  connectedCallback() {
    super.connectedCallback();

    this.#targets = [];

    for (const link of this.refs.links) {
      const targetId = link.dataset.target;
      const target = targetId ? document.getElementById(targetId) : null;
      if (target) this.#targets.push(target);
    }

    if (this.#targets.length === 0) return;

    this.#observer = new IntersectionObserver(this.#handleIntersect, { threshold: 0.4 });
    for (const target of this.#targets) this.#observer.observe(target);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  /** @type {IntersectionObserver | null} */
  #observer = null;

  /** @type {Element[]} */
  #targets = [];

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  #handleIntersect = (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const id = entry.target.id;
      for (const link of this.refs.links) {
        link.classList.toggle('active', link.dataset.target === id);
      }
    }
  };
}

if (!customElements.get('scroll-nav-component')) {
  customElements.define('scroll-nav-component', ScrollNavComponent);
}
